import React, { createContext, useState, useContext } from "react";

// Criando o contexto para o filtro de produtos
const ProductFilterContext = createContext();

// Provedor do contexto
export const ProductFilterProvider = ({ children }) => {
  const [filterCategory, setFilterCategory] = useState(""); // Categoria
  const [filterSubcategory, setFilterSubcategory] = useState(""); // Subcategoria

  return (
    <ProductFilterContext.Provider
      value={{ filterCategory, setFilterCategory, filterSubcategory, setFilterSubcategory }}
    >
      {children}
    </ProductFilterContext.Provider>
  );
};

// Hook para acessar o contexto
export const useProductFilter = () => useContext(ProductFilterContext);
